module.exports = __webpack_public_path__ + "static/product1-fc251760faa2e800b54ce98df5a478f5.png";